import Tool from '../Tool';
import { makeWhiteboardToolHandler } from './helpers';

/**
 * Handler for WhiteboardAgent::CreateDiagramOnWhiteboardTool
 * Creates diagrams on the whiteboard
 */
const createDiagramToolHandler = makeWhiteboardToolHandler(
  (toolCall, assistedWhiteboard) => {
    assistedWhiteboard.ensureVersionSaved();

    if (toolCall.content?.data) {
      const { diagram } = JSON.parse(toolCall.content.data) as any;

      // TODO we really need to send this back to the agent once done if we want it to be able to
      // reason about the created objects using frontend content
      assistedWhiteboard.actionAddDiagram(diagram);
    } else {
      console.warn(
        'No data provided to CreateDiagramOnWhiteboardTool',
        toolCall.content
      );
    }
  }
);

Tool.register(
  'WhiteboardAgent::CreateDiagramOnWhiteboardTool',
  createDiagramToolHandler
);
